import { render, staticRenderFns } from "./EditingDialog.vue?vue&type=template&id=22bfb873&scoped=true&"
import script from "./EditingDialog.vue?vue&type=script&lang=js&"
export * from "./EditingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bfb873",
  null
  
)

export default component.exports